import React from 'react';

import Button from '../../components/ButtonNew';
import {BriefcaseIcon} from '../../components/svg';
import {useAnalytics} from '../../hooks';
import {cx} from '../../util';
import {getBrandName} from '../../components/Brand';

const GetReferredCard = ({tag, numReferrers, className}) => {
  const {tracker} = useAnalytics();

  return (
    <div className={cx('bg-gray-50 border border-gray-200 rounded-lg p-4 flex justify-between items-center flex-col sm:flex-row', className)}>
      <div className="flex items-center mb-3 sm:mb-0">
        <BriefcaseIcon className="mr-3 shrink-0" />
        <div>
          <h4 className="text-base font-semibold text-gray-900">{`Need a ${tag.name} job referral?`}</h4>
          <span className="mt-0.5 block text-sm text-gray-600 mr-5">
            {`There are${numReferrers > 1 ? ` ${numReferrers}` : ''} users on ${getBrandName()} that can refer you for ${tag.name} roles.`}
          </span>
        </div>
      </div>
      <Button
        href={`/jobs/referrals/request?${tag.type}=${tag.id}`}
        onClick={() => tracker.hubClickGetReferred({tag: tag.id})}
        className="shrink-0 w-full sm:w-auto"
      >
        Get referred
      </Button>
    </div>
  );
};

export default GetReferredCard;
